










import { Component, Vue } from "vue-property-decorator";
// import { Action, Getter, Mutation } from "vuex-class";
import PartnerForm from "@/components/sale/forms/PartnerForm.vue";

@Component({
  components: { PartnerForm },
})
export default class extends Vue {}
